import L from 'leaflet';
import { toString } from 'lodash';

import * as layerOps from '../../api/Layers/layer-operations';

import * as styleOps from '../../api/Styles/style-operations';

/**
 * Builds the TMS layer for the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.layer - The layer object.
 * @param {object} arg.style - The style object.
 * @param {number} [arg.zIndex = 10] - The zIndex for the layer.
 * @returns {object} The leaflet layer to add to the map.
 */
const buildTMSLayer = ({ layer, style, zIndex = 10 }) => {
  return L.tileLayer(layerOps.getURL(layer), {
    format: 'image/png',
    tms: true,
    maxZoom: layerOps.getMaxZoom(layer),
    opacity: styleOps.getRasterOpacityPercentage(style) / 100,
    pane: toString(zIndex),
    attribution: layerOps.getAttribution(layer)
  });
};

export default buildTMSLayer;
